
export type id = number
export type Nullable<T> = T | null
export type DateTimeString = string

export interface GenericEntity {
   id: number
   name: string
   createDate: DateTimeString
   updateDate: DateTimeString
   contentType: ContentType
}

export interface idEntity {
	id: id
}

export interface NameEntity {
	name: string
}

export enum ContentType {
   home = "home",
   skillSet = "skillSet",
   lesson = "lesson"
}

export interface UmbracoContent extends GenericEntity {
   route: UmbracoRoute
}

export interface UmbracoContentList<T> {
   items: T[]
   total: number
}

interface UmbracoRoute {
   path: string
   startItem: UmbracoStartItem
}

interface UmbracoStartItem extends idEntity {
   path: string
}

export interface RichTextBlock {
   markup: HTMLElement
}

export interface UmbracoImage extends idEntity, NameEntity {
   url: string
}

export interface UmbracoVideo {
   url: string
   title: string
}